import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import AuthGate from './components/AuthGate';
import MemberGate from './components/MemberGate';
import AdminGate from './components/AdminGate';
import Home from './pages/Home';
import Login from './pages/Login';
import LoginSent from './pages/LoginSent';
import LoginCallback from './pages/LoginCallback';
import Profile from './pages/Profile';
import MyBoatPlaces from './pages/MyBoatPlaces';
import NewBoat from './pages/NewBoat';
import BoatDetail from './pages/BoatDetail';
import AdminMembers from './pages/AdminMembers';
import AdminMemberDetail from './pages/AdminMemberDetail';
import AdminBoatDetail from './pages/AdminBoatDetail';
import AdminBoatPlaces from './pages/AdminBoatPlaces';
import AdminBoatPlaceDetail from './pages/AdminBoatPlaceDetail';
import AdminAdmins from './pages/AdminAdmins';
import NewMember from './pages/NewMember';
import NewBoatPlace from './pages/NewBoatPlace';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/login/sent" element={<LoginSent />} />
      <Route path="/login/callback" element={<LoginCallback />} />
      <Route element={<Layout />}>
        <Route
          path="/"
          element={
            <AuthGate>
              <MemberGate>
                <Home />
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/profil"
          element={
            <AuthGate>
              <MemberGate>
                <Profile />
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/mina-batar"
          element={
            <AuthGate>
              <MemberGate>
                <MyBoatPlaces />
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/mina-batar/ny"
          element={
            <AuthGate>
              <MemberGate>
                <NewBoat />
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/mina-batar/:boatId"
          element={
            <AuthGate>
              <MemberGate>
                <BoatDetail />
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/admin"
          element={
            <AuthGate>
              <MemberGate>
                <AdminGate>
                  <Navigate to="/admin/medlemmar" replace />
                </AdminGate>
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/admin/medlemmar"
          element={
            <AuthGate>
              <MemberGate>
                <AdminGate>
                  <AdminMembers />
                </AdminGate>
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/admin/medlemmar/ny"
          element={
            <AuthGate>
              <MemberGate>
                <AdminGate>
                  <NewMember />
                </AdminGate>
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/admin/medlemmar/:uid"
          element={
            <AuthGate>
              <MemberGate>
                <AdminGate>
                  <AdminMemberDetail />
                </AdminGate>
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/admin/medlemmar/:uid/batar/:boatId"
          element={
            <AuthGate>
              <MemberGate>
                <AdminGate>
                  <AdminBoatDetail />
                </AdminGate>
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/admin/batplatser"
          element={
            <AuthGate>
              <MemberGate>
                <AdminGate>
                  <AdminBoatPlaces />
                </AdminGate>
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/admin/batplatser/ny"
          element={
            <AuthGate>
              <MemberGate>
                <AdminGate>
                  <NewBoatPlace />
                </AdminGate>
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/admin/batplatser/:placeId"
          element={
            <AuthGate>
              <MemberGate>
                <AdminGate>
                  <AdminBoatPlaceDetail />
                </AdminGate>
              </MemberGate>
            </AuthGate>
          }
        />
        <Route
          path="/admin/admins"
          element={
            <AuthGate>
              <MemberGate>
                <AdminGate>
                  <AdminAdmins />
                </AdminGate>
              </MemberGate>
            </AuthGate>
          }
        />
      </Route>
    </Routes>
  );
}
